<div class="popup-header">
    <button class="close-btn" aria-label="close dialog" (click)="closePopup()">
        <img src="/icons/close-light-grey.svg" alt="" />
    </button>
</div>
<div class="body-section">
    <p class="popup-head-text mb-4">{{'SelectAllVehicalPopup.p1'|cxTranslate}}</p>
    <!-- <p class="desc">{{'SelectAllVehicalPopup.p2'|cxTranslate}}</p>
        <p class="desc">{{'SelectAllVehicalPopup.p3'|cxTranslate}}</p> -->
    <p class="desc">{{'SelectAllVehicalPopup.p4'|cxTranslate}}</p>
</div>